import { IconButton, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { TbArrowsRightLeft } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import NavProf from '../Icons/NavProf';
import NavUI from '../Icons/NavUI';
import BackToViz from './BackToViz';
import UserProfile from './UserProfile';
import Icon from '../Icon/Icon';

export const USER_PROFILE = 'user-profile';

interface Props {
    menuItem: any;
    t: any;
}

const ComponentMap: Record<string, any> = {
    [USER_PROFILE]: {
        icon: <NavProf />,
        component: <UserProfile />,
    },
    'pa-upload-documents': {
        icon: <NavUI />,
        component: null,
    },
    settings: {
        icon: <Icon name={'NavSet'} />,
        component: null,
    },
    'upload-documents': {
        icon: <NavUI />,
        component: null,
    },
    'current-viz': { icon: <TbArrowsRightLeft />, component: <BackToViz /> },
};

function NavMenuItem({ t, menuItem }: Props) {
    const { path, key } = menuItem || {};
    const router = useNavigate();

    const handleOnClick = () => {
        path && router(path);
    };

    if (ComponentMap[key]?.component) {
        return React.cloneElement(ComponentMap[key]?.component, {
            path,
            name: key,
            key,
            t,
            icon: ComponentMap[key]?.icon,
        });
    } else {
        return (
            <Tooltip
                aria-label={key}
                label={t(`ui.mm.tooltip.${key}`)}
                hasArrow>
                <IconButton
                    variant="navbar"
                    aria-label={key}
                    icon={ComponentMap[key]?.icon || 'NavDash'}
                    p="10px"
                    ml="15px"
                    onClick={handleOnClick}
                />
            </Tooltip>
        );
    }
}

NavMenuItem.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('translations')(NavMenuItem);
